import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Container,
  ProgressSection,
  ProgressDot,
  ProgressLabel,
  InProgressPill,
  ProgressBarTrack,
  ProgressBarFill,
  SubBarsContainer,
  SubBarRow,
  SubBarLabel
} from './style'

const ProgressSectionComponent = ({ percent, target, status, labelId, labelDefaultMessage, isDraft = true, subBars }) => {
  return (
    <Container>
      <ProgressSection>
        <ProgressDot tone={status ? 'complete' : 'inProgress'} />
        <ProgressLabel>
          <FormattedMessage id={labelId} defaultMessage={labelDefaultMessage} values={{ percent }} />
        </ProgressLabel>
        {isDraft && percent < 100 && (
          <InProgressPill>
            <FormattedMessage id="monitoringInProgress" defaultMessage="In progress" />
          </InProgressPill>
        )}
      </ProgressSection>
      {subBars && subBars.length > 0 ? (
        <SubBarsContainer>
          {subBars.map((bar, index) => (
            <SubBarRow key={index}>
              <SubBarLabel>
                {bar.labelId ? (
                  <FormattedMessage id={bar.labelId} defaultMessage={bar.labelDefaultMessage} />
                ) : (
                  bar.label
                )}
              </SubBarLabel>
              <ProgressBarTrack style={{ marginBottom: 0, flex: 1 }}>
                <ProgressBarFill percent={bar.percent} tone={bar.percent === 100 ? 'complete' : 'inProgress'} />
              </ProgressBarTrack>
            </SubBarRow>
          ))}
        </SubBarsContainer>
      ) : (
        <ProgressBarTrack style={{ marginBottom: 0 }}>
          <ProgressBarFill percent={percent} tone={status ? 'complete' : 'inProgress'} />
        </ProgressBarTrack>
      )}
    </Container>
  )
}

export default ProgressSectionComponent
